import { GridFooterContainer } from '@mui/x-data-grid/components/containers/GridFooterContainer';
import { Box, Typography } from '@mui/material';

export interface TotalsFotterProps {
  total: number;
  count: number;
}

function TotalsFooter({ total, count }: TotalsFotterProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <Typography variant="body2">
        Showing {count} of {total} records
      </Typography>
    </Box>
  );
}

export default TotalsFooter;
